<template lang="pug">
  include /mixins
  +b.modal-wrapper--bg-contrast
    +e.close(@click='$emit("close")') 
      icon(type='close')
    card
      card-panel
        +b.FORM.form
          row(offset)
            cell(cols='12')
              +b.UI-TABS.tabs.mt-1(ref='tab')
                template(v-slot='{ activeItem,activate: activateTab }')
                  +b.tab-list
                    +e.body
                      +e.toggle--variant_default.tab-list__item(
                        @click='activate(index);activateTab(index)'
                        v-for='(item, index) in stepsList'
                      )
                        v-caption(
                          :color="activeItem === index ? 'default' : 'brand-5' "
                        ) {{ item.name }}
      card(variant='section' stacked='top')
        card-panel(offset='vertical')
          loading-wrapper(:loading='loading' )
            row(offset) 
              cell(cols='12')
                card(:variant='["offset"]')
                  card-panel(offset='horizontal')
                    transition-group(name='fade')
                      ui-show-tickets-form(
                        :descriptors='descriptors'
                        :show='show'
                        key='1'
                        type='print'
                        @close='$emit("close")'
                        v-if='stepsList[0].active'
                      )
                        | {{ _('t Print hard tickets')}}
                      ui-printed-list(
                        v-if='stepsList[1].active'
                        :id='show.id' 
                        key='2'
                      )
                      

</template>

<script>
  // import { mapActions } from 'vuex'
  import UiTabs from '@cabinet/components/vendor/UiTabs'
  import UiShowTicketsForm from '@cabinet/components/show/modals/agents/UiShowTicketsForm'
  import UiPrintedList from '@cabinet/components/show/modals/tickets/UiPrintedList'

  export default {
    components: {
      UiTabs,
      UiShowTicketsForm,
      UiPrintedList,
      
    },
    props: {
      show: {
        required: true
      },
      descriptors: {
        required: true
      }
    },
    data() {
      return {
        stepsList: [
          {
            name: this._('a Print hard tickets'),
            active: true
          },
          {
            name: this._('a Hard tickets list'),
            active: false
          },
        ],
        loading: false
      }
    },
    methods: {
      activate(index) {
        this.stepsList.forEach(s => s.active = false)
        this.stepsList[index].active = true
      },
      
    },
  }
</script>